<template>
    <div class="about">
      <div class="header">
      <HeaderBar></HeaderBar>
      <HeaderMenu :cartQty=cartQty :productSalesPrice=productSalesPrice @childEvent="popupCheckout"></HeaderMenu>
      <AppLoading v-if="loading" />
      </div>
  
      <div class="content">
              <!-- <v-card class="mt-1 mx-auto bg-background pa-3" elevation="0" >
          <div class="d-flex flex-column fill-height justify-center align-center text-black ">
            <h1 class="primary--text">
              {{ getBannerDetails.title }}
            </h1>
          </div>
        </v-card> -->
        <v-container fluid>
          <div v-html="getBannerDetails.details" class="text-justify"></div>
        </v-container>
       
      </div>
  
      <div class="footer">
      <FooterSection ></FooterSection>
      </div>
    </div>
  </template>
  
  
  <script>
  import { defineComponent } from 'vue';
  import { mapActions,mapGetters } from "vuex";
  // Components
  // import HelloWorld from '../components/HelloWorld.vue';
  
  import HeaderBar from '../components/HeaderBar.vue';
  import HeaderMenu from '../components/HeaderMenu.vue';
  import AppLoading from "../components/Loading.vue";
  import FooterSection from '../components/Footer.vue';
  export default defineComponent({
    name: 'SaftyTipsView',
    data: () => ({
      productSalesPrice: "0.00",
      cartQty:0,
    }),
    components: {
      HeaderBar,
      HeaderMenu,
      AppLoading,
      FooterSection,
    },
    computed: {
      ...mapGetters([
        "authStatus",
        "authStatusError",
        "authStatusresponse",
        "getBannerDetails",
      ]),
      loading: function () {
        return this.authStatus === "loading";
      },
    },
    created() {
      this.fetchPageDetails("7");
    },
    methods: {
      ...mapActions([
        "fetchPageDetails",
      ]),
    }
  });
  
  </script>